export const RANGES = [
  { value: '', label: 'Any time' },
  { value: '7', label: '7 days' },
  { value: '30', label: '30 days' },
  { value: '90', label: '90 days' },
] as const;

/** Start date for "the last N days". Counted back from the newest report rather than today, so a library that
 * stops before today still shows that week's research instead of nothing. */
export function fromForRange(range: string, newest: string | undefined): string {
  const days = Number(range);
  if (!days || !newest) return '';
  const [y = 0, m = 1, d = 1] = newest.split('-').map(Number);
  const start = new Date(Date.UTC(y, m - 1, d - days + 1));
  return start.toISOString().slice(0, 10);
}

/** Analysts travel in the URL as one comma-separated value, the form the API takes. */
export const splitList = (value: string) => value.split(',').map((v) => v.trim()).filter(Boolean);
export const joinList = (values: string[]) => values.join(',');

const either = (names: string[]) => (names.length > 2 ? `${names.slice(0, -1).join(', ')} or ${names.at(-1) ?? ''}` : names.join(' or '));

type Active = { q: string; assetClass: string; analysts: string[]; currency: string };

/** Why nothing matched, in words: "Nothing in Rates by Frances Cheung mentions "USD/MYR"." */
export function noMatchReason({ q, assetClass, analysts, currency }: Active): string {
  const where = [assetClass ? `in ${assetClass}` : '', analysts.length ? `by ${either(analysts)}` : '', currency ? `tagged ${currency}` : '']
    .filter(Boolean)
    .join(' ');
  const what = q ? `mentions "${q}"` : 'matches';
  return `Nothing ${where ? `${where} ` : ''}${what}.`;
}
